import angular from 'angular';

function DetailComboRequiredItemController() {}

export const EventsDetailComboRequiredItemComponentModule = angular
  .module('acme.view.events.detail.components.detail-combo-required-item', [])
  .component('acmeDetailComboRequiredItem', {
    templateUrl: 'views/detail/components/detail-combo-required-item/detail-combo-required-item.component.tpl.html',
    controller: DetailComboRequiredItemController,
    bindings: {
      entry: '<',
    },
  }).name;
